import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import XCloseIcon from "assets/icons/HeroIcons/XCloseIcon";
import { RootState } from "store";
import { useSelector } from "react-redux";
import {
  closeDeleteFormModalAction,
  closeformDetailsAction,
} from "store/modals/reducer.actions";
import { useDispatch } from "react-redux";
import apiLibrary from "services/api";
import { Toasts } from "view/components/Toasts";
import Button from "view/components/Button";
import { useNavigate } from "react-router-dom";
import { fetchDynamicFormsAction } from "store/dynamicForms";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";

const style: React.CSSProperties = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "10px",
  backgroundColor: "#ffff",
};

interface FormDeleteModalProps {}

export const FormDeleteModal: React.FC<FormDeleteModalProps> = () => {
  const { deleteFormModal } = useSelector((state: RootState) => state.modals);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();

  const handleClose = () => {
    if (isLoading) return;
    dispatch(closeDeleteFormModalAction());
  };

  const deleteForm = async () => {
    setIsLoading(true);
    try {
      const res = await apiLibrary.Forms.deleteForm(deleteFormModal.data.id);
      Toasts.success(res.message);
      handleClose();
      dispatch(fetchDynamicFormsAction());
      dispatch(closeformDetailsAction());
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error.message;
      Toasts.error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  const isObservationsSubmitted = deleteFormModal.data.numberOfObservations > 0;
  return (
    <Modal
      open={deleteFormModal?.isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      disableAutoFocus={true}
      aria-describedby="modal-modal-description"
      className="border-none"
    >
      <Box sx={style} className="dark:bg-secondaryLight ">
        <div className="flex flex-col justify-start items-start w-[500px]  overflow-y-auto rounded-lg">
          <div
            className="relative flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-4 p-6 rounded-lg dark:bg-secondaryLight bg-bgWhite"
            style={{
              boxShadow:
                "0px 2px 8px 0 rgba(2,13,36,0.1), 0px 2px 24px 0 rgba(2,13,36,0.08)",
            }}
          >
            <div className="flex  justify-between items-start self-stretch flex-grow-0 flex-shrink-0 py-0.5">
              <div className="relative flex items-center self-stretch justify-start flex-grow-0 flex-shrink-0">
                <p className="flex-grow text-xl font-semibold text-left text-textMid dark:text-textMain">
                  {isObservationsSubmitted
                    ? "Form cannot be Deleted"
                    : "Delete Form ?"}
                </p>
              </div>
              <button title="close" onClick={handleClose} type="button">
                <XCloseIcon width={24} height={24} viewBox="0 0 24 24" />
              </button>
            </div>
            <div className="flex justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative gap-2 pb-1.5">
              <p className="flex-grow w-[440px] text-sm text-left text-textMid  dark:text-textMain">
                {isObservationsSubmitted
                  ? `This form cannot be deleted as it has observations associated with it.
                     Want to delete this form? Delete the associated observations first.`
                  : `Are you sure you want to delete this form? This action cannot be undone.`}
              </p>
            </div>

            <div className="flex items-center self-stretch justify-end flex-grow-0 flex-shrink-0 gap-2">
              <Button
                type="button"
                text={isObservationsSubmitted ? "Close" : "Cancel"}
                filledColor="primary"
                outlinedColor="primary"
                textColor="textWhite"
                className="px-5 py-2"
                width="35"
                height="13"
                fontStyle="font-semibold"
                variant={isObservationsSubmitted ? "filled" : "outlined"}
                onClick={handleClose}
              />

              {!isObservationsSubmitted && (
                <Button
                  disabled={isLoading}
                  type="button"
                  text="Delete"
                  filledColor="primary"
                  outlinedColor="primary"
                  textColor="textWhite"
                  className="px-5 py-2"
                  width="35"
                  height="13"
                  fontStyle="font-semibold"
                  variant="filled"
                  onClick={deleteForm}
                />
              )}
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};
